(() => {
  const qs=(s,c=document)=>c.querySelector(s), qsa=(s,c=document)=>[...c.querySelectorAll(s)];

  const root=document.documentElement;
  const modeButton=qs('[data-color-mode-toggle]');
  const themeMeta=qs('[data-theme-color]');
  const configured=root.dataset.themeDefault || 'dark';
  const resolveSystem=()=>window.matchMedia && window.matchMedia('(prefers-color-scheme: light)').matches?'light':'dark';
  const applyMode=(mode,persist=true)=>{const resolved=mode==='system'?resolveSystem():mode;root.dataset.theme=resolved;root.style.colorScheme=resolved;if(themeMeta){const styles=getComputedStyle(root);themeMeta.setAttribute('content',styles.getPropertyValue('--header-bg').trim())}if(modeButton){modeButton.setAttribute('aria-pressed',String(resolved==='light'));modeButton.setAttribute('aria-label',resolved==='dark'?'Switch to light mode':'Switch to dark mode')}if(persist){try{localStorage.setItem('aerial-color-mode',resolved)}catch(e){}}};
  if(modeButton){modeButton.addEventListener('click',()=>applyMode(root.dataset.theme==='dark'?'light':'dark'));applyMode(root.dataset.theme||configured,false)}
  if(configured==='system' && window.matchMedia){window.matchMedia('(prefers-color-scheme: light)').addEventListener?.('change',()=>{let saved=null;try{saved=localStorage.getItem('aerial-color-mode')}catch(e){}if(!saved)applyMode('system',false)})}

  const menu=qs('[data-mobile-menu]'), open=qs('[data-menu-toggle]'), close=qs('[data-menu-close]'), header=qs('[data-header]');
  let menuHome=null;
  if(menu){menuHome=document.createComment('mobile-menu-home');menu.parentNode?.insertBefore(menuHome,menu);}
  const syncMenuVars=()=>{if(!menu||!header)return;const cs=getComputedStyle(header);['--header-surface','--header-ink','--header-border','--header-logo-width','--header-font-size'].forEach(v=>{const val=cs.getPropertyValue(v).trim();if(val)menu.style.setProperty(v,val);});};
  const setMenu=(show)=>{
    if(!menu||!open)return;
    if(show){
      syncMenuVars();
      if(menu.parentNode!==document.body)document.body.appendChild(menu);
      menu.hidden=false;
      open.setAttribute('aria-expanded','true');
      document.body.classList.add('menu-open');
      document.documentElement.classList.add('mobile-menu-open');
      header?.classList.add('header-menu-open');
      header?.classList.remove('header-scroll-hidden');
      requestAnimationFrame(()=>close?.focus());
    }else{
      menu.hidden=true;
      open.setAttribute('aria-expanded','false');
      document.body.classList.remove('menu-open');
      document.documentElement.classList.remove('mobile-menu-open');
      header?.classList.remove('header-menu-open');
      if(menuHome?.parentNode)menuHome.parentNode.insertBefore(menu,menuHome.nextSibling);
      requestAnimationFrame(()=>open.focus({preventScroll:true}));
    }
  };
  open?.addEventListener('click',()=>setMenu(true));
  close?.addEventListener('click',()=>setMenu(false));
  menu?.addEventListener('click',e=>{if(e.target.closest('a[href]'))setMenu(false);});
  document.addEventListener('keydown',e=>{if(e.key==='Escape'&&menu&&!menu.hidden)setMenu(false);});
  window.addEventListener('pageshow',()=>{if(menu&&!menu.hidden)setMenu(false);});
  qsa('[data-product-section]').forEach(section=>{const json=qs('[data-product-json]',section);const form=qs('[data-product-form]',section);if(!json||!form)return;let variants=[];try{variants=JSON.parse(json.textContent)}catch(e){return}const options=qsa('input[name^="options"]',form);const idInput=qs('[data-variant-id]',form),button=qs('[data-add-to-cart]',form),label=qs('[data-add-label]',form);
    const update=()=>{const selected=qsa('input[name^="options"]:checked',form).map(i=>i.value);const variant=variants.find(v=>v.options.every((o,i)=>o===selected[i]));if(!variant){button.disabled=true;label.textContent='Unavailable';return}idInput.value=variant.id;button.disabled=!variant.available;label.textContent=variant.available?'Add to cart':'Sold out';const url=new URL(location.href);url.searchParams.set('variant',variant.id);history.replaceState({},'',url);};options.forEach(i=>i.addEventListener('change',update));
  });
  document.addEventListener('shopify:section:load',()=>location.reload());
})();

/* Stable scroll reveal and parallax */
(() => {
  const body = document.body;
  if (!body || body.dataset.scrollReveal !== 'true') return;
  if (body.classList.contains('reduce-motion') || matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  const style = body.dataset.revealStyle || 'fade-up';
  const behavior = body.dataset.revealBehavior || 'once';
  const threshold = Math.max(0.01, Math.min(0.6, Number(body.dataset.revealThreshold) || 0.15));
  const stagger = parseInt(getComputedStyle(document.documentElement).getPropertyValue('--reveal-stagger'), 10) || 70;
  const selector = ['h1','h2','h3','.eyebrow','.rte','.button','.product-card','article','.mv-card','.mv-panel','.mv-metric','.drone-card','[class*="__media"]','[class*="__content"]'].join(',');

  const mark = (scope) => {
    const candidates = [...scope.querySelectorAll(selector)].filter((el) => {
      if (el.closest('.site-header,.mobile-menu,[data-scroll-reveal-item]')) return false;
      if (el.matches('script,style,template,[hidden],.visually-hidden,.article-page,.article-page__content')) return false;
      const r = el.getBoundingClientRect();
      return r.width > 2 && r.height > 2;
    });
    candidates.slice(0, 36).forEach((el, i) => {
      el.dataset.scrollRevealItem = '';
      el.dataset.revealStyle = el.dataset.revealStyle || style;
      el.style.setProperty('--reveal-delay', `${Math.min(i,10) * stagger}ms`);
    });
    return candidates.slice(0,36);
  };

  const items = [...document.querySelectorAll('#MainContent .shopify-section,#MainContent>section,.site-footer')].flatMap(mark);
  if (!items.length) return;
  document.documentElement.classList.add('motion-ready');

  const revealObserver = new IntersectionObserver((entries) => {
    requestAnimationFrame(() => entries.forEach((entry) => {
      if (!entry.isIntersecting) return;
      entry.target.classList.add('is-revealed');
      if (behavior === 'once') {
        revealObserver.unobserve(entry.target);
        hideObserver.unobserve(entry.target);
      }
    }));
  }, { threshold, rootMargin: '0px 0px -5% 0px' });

  const hideObserver = new IntersectionObserver((entries) => {
    if (behavior !== 'replay') return;
    requestAnimationFrame(() => entries.forEach((entry) => {
      if (!entry.isIntersecting && entry.target.classList.contains('is-revealed')) {
        entry.target.classList.remove('is-revealed');
      }
    }));
  }, { threshold: 0, rootMargin: '120px 0px 120px 0px' });

  items.forEach((item) => { revealObserver.observe(item); hideObserver.observe(item); });

  if (body.dataset.imageParallax === 'true') {
    const media = [...document.querySelectorAll('#MainContent img')].filter(img => !img.closest('.product-card,.site-header') && img.width > 280 && img.height > 180).map(img => img.parentElement).filter(Boolean);
    media.forEach(el => el.dataset.parallaxMedia = '');
    let ticking = false;
    const update = () => {
      const vh = innerHeight;
      media.forEach(el => {
        const r = el.getBoundingClientRect();
        if (r.bottom < -100 || r.top > vh + 100) return;
        const p = ((r.top + r.height / 2) - vh / 2) / vh;
        el.style.setProperty('--parallax-y', `calc(${p.toFixed(3)} * var(--parallax-strength))`);
      });
      ticking = false;
    };
    const requestUpdate = () => { if (!ticking) { ticking = true; requestAnimationFrame(update); } };
    addEventListener('scroll', requestUpdate, { passive:true });
    addEventListener('resize', requestUpdate, { passive:true });
    requestUpdate();
  }

  document.addEventListener('shopify:section:select', e => e.target.querySelectorAll('[data-scroll-reveal-item]').forEach(el => el.classList.add('is-revealed')));
})();


(() => {
  const initArticlesCarousels = (scope = document) => {
    scope.querySelectorAll('[data-articles-carousel]').forEach((section) => {
      if (section.dataset.carouselReady === 'true') return;
      const viewport = section.querySelector('[data-articles-viewport]');
      const track = section.querySelector('.articles-carousel__track');
      const cards = [...section.querySelectorAll('.article-card')];
      const prev = section.querySelector('[data-articles-prev]');
      const next = section.querySelector('[data-articles-next]');
      if (!viewport || !track || cards.length < 2) return;
      section.dataset.carouselReady = 'true';
      let index = 0;
      const visibleCount = () => window.innerWidth < 750 ? 1 : window.innerWidth < 990 ? 2 : 3;
      const maxIndex = () => Math.max(0, cards.length - visibleCount());
      const update = () => {
        index = Math.min(index, maxIndex());
        const cardWidth = cards[0].getBoundingClientRect().width;
        const gap = parseFloat(getComputedStyle(track).gap) || 0;
        track.style.transform = `translate3d(${-index * (cardWidth + gap)}px,0,0)`;
        if (prev) prev.disabled = index === 0;
        if (next) next.disabled = index >= maxIndex();
      };
      prev?.addEventListener('click', () => { index = Math.max(0, index - 1); update(); });
      next?.addEventListener('click', () => { index = Math.min(maxIndex(), index + 1); update(); });
      let startX = 0;
      viewport.addEventListener('pointerdown', e => { startX = e.clientX; });
      viewport.addEventListener('pointerup', e => { const delta = e.clientX - startX; if (Math.abs(delta) > 50) { index = delta < 0 ? Math.min(maxIndex(), index + 1) : Math.max(0, index - 1); update(); } });
      window.addEventListener('resize', update, { passive: true });
      update();
    });
  };
  document.addEventListener('DOMContentLoaded', () => initArticlesCarousels());
  document.addEventListener('shopify:section:load', e => initArticlesCarousels(e.target));
})();



(() => {
  const body = document.body;
  if (!body || window.Shopify?.designMode) return;

  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const duration = reducedMotion ? 0 : Math.min(parseInt(getComputedStyle(body).getPropertyValue('--page-transition-duration'), 10) || 180, 240);
  let leaving = false;

  const isInternalPageLink = (link, event) => {
    if (!link || leaving || event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return false;
    if (link.target && link.target !== '_self') return false;
    if (link.hasAttribute('download') || link.dataset.noTransition != null) return false;
    const raw = link.getAttribute('href');
    if (!raw || raw.startsWith('#') || raw.startsWith('mailto:') || raw.startsWith('tel:') || raw.startsWith('javascript:')) return false;
    const url = new URL(link.href, location.href);
    if (url.origin !== location.origin) return false;
    if (url.pathname === location.pathname && url.search === location.search && url.hash) return false;
    if (/\/(cart|checkout|checkouts|account|challenge|admin)(\/|$)/i.test(url.pathname)) return false;
    return true;
  };

  const markDestination = () => {
    try { sessionStorage.setItem('mv-page-transition','1'); } catch(e) {}
  };

  document.addEventListener('click', event => {
    const link = event.target.closest('a[href]');
    if (!isInternalPageLink(link, event)) return;
    event.preventDefault();
    leaving = true;
    markDestination();
    body.classList.add('is-page-leaving');
    window.setTimeout(() => { window.location.assign(link.href); }, duration);
  });

  const revealPage = () => {
    leaving = false;
    body.classList.remove('is-page-leaving','is-page-entering','is-page-loading');
    if (document.documentElement.classList.contains('mv-page-arriving')) {
      document.documentElement.classList.add('mv-page-arrived');
      try { sessionStorage.removeItem('mv-page-transition'); } catch(e) {}
      window.setTimeout(() => document.documentElement.classList.remove('mv-page-arriving','mv-page-arrived'), 260);
    }
  };

  if (document.readyState === 'complete') revealPage();
  else window.addEventListener('load', revealPage, { once:true });
  window.addEventListener('pageshow', revealPage);
})();


(() => {
  const clamp = (n,min,max) => Math.max(min,Math.min(max,n));
  const smoothstep = (a,b,t) => {
    const x = clamp((t-a)/(b-a),0,1);
    return x*x*(3-2*x);
  };

  const initCanisterStories = (scope=document) => {
    const stories = [...scope.querySelectorAll('[data-canister-scroll-story]')];
    if (!stories.length) return;

    const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (reduce) return;

    let ticking = false;
    const update = () => {
      const vh = window.innerHeight || document.documentElement.clientHeight;
      stories.forEach(section => {
        const rect = section.getBoundingClientRect();
        const scrollable = Math.max(1, rect.height - vh);
        const progress = clamp((-rect.top) / scrollable, 0, 1);
        const styles = getComputedStyle(section);
        const start = parseFloat(styles.getPropertyValue('--css-crossfade-start')) || .25;
        const end = parseFloat(styles.getPropertyValue('--css-crossfade-end')) || .5;
        const mix = smoothstep(start, end, progress);
        const zoomProgress = smoothstep(Math.max(start,.36), .98, progress);
        section.style.setProperty('--css-progress', progress.toFixed(4));
        section.style.setProperty('--css-frame-mix', mix.toFixed(4));
        section.style.setProperty('--css-zoom-progress', zoomProgress.toFixed(4));
      });
      ticking = false;
    };
    const requestUpdate = () => {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(update);
    };
    window.addEventListener('scroll', requestUpdate, {passive:true});
    window.addEventListener('resize', requestUpdate, {passive:true});
    requestUpdate();
  };

  initCanisterStories();
  document.addEventListener('shopify:section:load', e => initCanisterStories(e.target));
})();


// Direction-aware floating header
(() => {
  const initIdleHeader = (scope = document) => {
    const header = scope.querySelector?.('[data-header]') || document.querySelector('[data-header]');
    if (!header || header.dataset.hideOnScroll !== 'true' || header.dataset.idleHeaderReady === 'true') return;
    header.dataset.idleHeaderReady = 'true';

    let lastY = Math.max(window.scrollY || 0, 0);
    let idleTimer = 0;
    let ticking = false;
    const delta = 6;
    const topZone = 48;
    const idleDelay = parseInt(getComputedStyle(header).getPropertyValue('--header-scroll-idle'), 10) || 1400;

    const menuIsOpen = () => {
      const menu = document.querySelector('[data-mobile-menu]');
      return !!(menu && !menu.hidden);
    };

    const clearIdle = () => {
      if (idleTimer) window.clearTimeout(idleTimer);
      idleTimer = 0;
    };

    const show = (glassy = true) => {
      clearIdle();
      header.classList.remove('header-scroll-hidden');
      header.classList.add('header-scroll-visible');
      header.classList.toggle('header-scroll-glass', glassy);
    };

    const hide = () => {
      if (window.scrollY <= topZone || menuIsOpen() || header.matches(':focus-within') || header.matches(':hover')) {
        show(window.scrollY > topZone);
        return;
      }
      clearIdle();
      header.classList.remove('header-scroll-visible');
      header.classList.add('header-scroll-hidden');
    };

    const scheduleIdleHide = () => {
      clearIdle();
      if (window.scrollY <= topZone || menuIsOpen()) return;
      idleTimer = window.setTimeout(hide, idleDelay);
    };

    const update = () => {
      const y = Math.max(window.scrollY || 0, 0);
      const diff = y - lastY;

      if (y <= topZone) {
        show(false);
        clearIdle();
      } else if (diff > delta) {
        hide();
      } else if (diff < -delta) {
        show(true);
        scheduleIdleHide();
      }

      if (Math.abs(diff) > delta) lastY = y;
      ticking = false;
    };

    const onScroll = () => {
      clearIdle();
      if (!ticking) {
        ticking = true;
        requestAnimationFrame(update);
      }
    };

    if (window.scrollY <= topZone) show(false); else hide();
    window.addEventListener('scroll', onScroll, { passive: true });

    header.addEventListener('mouseenter', clearIdle);
    header.addEventListener('mouseleave', () => {
      if (header.classList.contains('header-scroll-visible')) scheduleIdleHide();
    });
    header.addEventListener('focusin', clearIdle);
    header.addEventListener('focusout', () => scheduleIdleHide());

    document.addEventListener('click', event => {
      if (event.target.closest('[data-menu-toggle]')) {
        requestAnimationFrame(() => {
          if (menuIsOpen()) {
            header.classList.add('header-menu-open');
            show(true);
          } else {
            header.classList.remove('header-menu-open');
            scheduleIdleHide();
          }
        });
      }
      if (event.target.closest('[data-menu-close]')) {
        header.classList.remove('header-menu-open');
        show(true);
        scheduleIdleHide();
      }
    });
  };

  initIdleHeader();
  document.addEventListener('shopify:section:load', event => initIdleHeader(event.target));
})();

/* Lightweight global skeleton loaders for content media */
(() => {
  const root = document.getElementById('MainContent');
  if (!root) return;

  const skip = (el) => !!el.closest('.site-header,.mobile-menu,.site-footer') || el.matches('[data-no-skeleton]');
  const hasSource = (el) => {
    if (el.tagName === 'IMG') return !!(el.currentSrc || el.getAttribute('src') || el.getAttribute('srcset'));
    if (el.tagName === 'VIDEO') return !!(el.currentSrc || el.getAttribute('src') || el.querySelector('source[src]'));
    return false;
  };
  const isReady = (el) => el.tagName === 'IMG' ? (el.complete && el.naturalWidth > 0) : el.readyState >= 2;
  const sourceKey = (el) => el.tagName === 'IMG'
    ? `${el.getAttribute('src') || ''}|${el.getAttribute('srcset') || ''}`
    : `${el.getAttribute('src') || ''}|${[...el.querySelectorAll('source')].map(s => s.getAttribute('src') || '').join('|')}`;

  const finish = (el, failed = false) => {
    el.classList.remove('mv-skeleton-loading');
    el.classList.toggle('mv-skeleton-error', failed);
    el.classList.toggle('mv-skeleton-loaded', !failed);
  };

  const prepare = (el) => {
    if (!(el instanceof HTMLImageElement || el instanceof HTMLVideoElement) || skip(el) || !hasSource(el)) return;
    const key = sourceKey(el);
    if (el.dataset.skeletonSource === key && (el.classList.contains('mv-skeleton-loading') || el.classList.contains('mv-skeleton-loaded'))) return;
    el.dataset.skeletonSource = key;
    el.classList.remove('mv-skeleton-loaded','mv-skeleton-error');
    if (isReady(el)) { finish(el); return; }
    el.classList.add('mv-skeleton-loading');
    const okEvent = el.tagName === 'IMG' ? 'load' : 'loadeddata';
    el.addEventListener(okEvent, () => finish(el), { once:true });
    el.addEventListener('error', () => finish(el, true), { once:true });
  };

  const scan = (scope = root) => {
    if (scope.matches?.('img,video')) prepare(scope);
    scope.querySelectorAll?.('img,video').forEach(prepare);
  };

  scan();

  const observer = new MutationObserver((mutations) => {
    mutations.forEach((mutation) => {
      if (mutation.type === 'attributes') prepare(mutation.target);
      mutation.addedNodes.forEach((node) => { if (node.nodeType === 1) scan(node); });
    });
  });
  observer.observe(root, { subtree:true, childList:true, attributes:true, attributeFilter:['src','srcset'] });
  document.addEventListener('shopify:section:load', (event) => scan(event.target));
})();
